export default {   
    all: function(params) {
        return window.axios.get(`retailerHistory`, {params: params});
    },
    get: function(params, id){
        return window.axios.get(`retailerHistory/${id}`, {params: params});
    }
}